import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { Modal } from 'react-bootstrap'
import {
  cancelBusinessAddressModalDialog,
  closeBusinessAddressModalDialog,
  resetBusinessAddressModalDialog,
  saveChangesBusinessAddressModalDialog,
  validateBusinessAddressModalDialog,
} from '../../actions/business_address_modal_dialog'
import BusinessAddressForm from './business_address_form'
import { fetchBusinessById } from '../../actions/business'

const BusinessAddressModalDialog = ({
  fetchBusinessById,
  closeBusinessAddressModalDialog,
  data,
  isModalDialogOpen,
  cancelBusinessAddressModalDialog,
  isChangesSaved,
  onHide,
  business,
}) => {
  const handleCloseModal = () => {
    fetchBusinessById(data.id)
    closeBusinessAddressModalDialog()
  }
  return (
    <Modal
      show={isModalDialogOpen}
      onHide={() => {
        onHide()
        if (isChangesSaved) {
          handleCloseModal()
        } else {
          cancelBusinessAddressModalDialog()
        }
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit Business Address</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <BusinessAddressForm data={data} business={business} />
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  isChangesSaved: state.businessAddressModalDialog.isChangesSaved,
  isValidated: state.businessAddressModalDialog.isValidated,
  newData: state.businessAddressModalDialog.newData,
  isModalDialogOpen: state.businessAddressModalDialog.isModalDialogOpen,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      closeBusinessAddressModalDialog,
      cancelBusinessAddressModalDialog,
      saveChangesBusinessAddressModalDialog,
      validateBusinessAddressModalDialog,
      resetBusinessAddressModalDialog,
      fetchBusinessById,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BusinessAddressModalDialog))
